import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "delete-outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-delete-outline',
    templateUrl: './icon-delete-outline.component.html',
    styleUrls: ['./icon-delete-outline.component.scss'],
    standalone: false
})
export class IconDeleteOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
